export default __webpack_public_path__ + "static/clear-headings-do-701ac15ccdb6d5482a560299278762a3d818f5f25118fee5d61250362071d5ba.png";